export const generateDXF = (points, contourLines, triangles) => {
  let dxf = '';
  
  // Cabecera DXF
  dxf += '0\nSECTION\n';
  dxf += '2\nHEADER\n';
  dxf += '9\n$ACADVER\n1\nAC1015\n';
  dxf += '0\nENDSEC\n';
  
  // Sección de tablas
  dxf += '0\nSECTION\n';
  dxf += '2\nTABLES\n';
  
  // Tabla de capas
  dxf += '0\nTABLE\n';
  dxf += '2\nLAYER\n';
  dxf += '70\n3\n';
  
  // Capa para puntos
  dxf += '0\nLAYER\n';
  dxf += '2\nPUNTOS\n';
  dxf += '70\n0\n';
  dxf += '62\n1\n'; // Color rojo
  dxf += '6\nCONTINUOUS\n';
  
  // Capa para curvas de nivel
  dxf += '0\nLAYER\n';
  dxf += '2\nCURVAS\n';
  dxf += '70\n0\n';
  dxf += '62\n3\n'; // Color verde
  dxf += '6\nCONTINUOUS\n';
  
  // Capa para triangulación
  dxf += '0\nLAYER\n';
  dxf += '2\nTRIANGULOS\n';
  dxf += '70\n0\n';
  dxf += '62\n8\n'; // Color gris
  dxf += '6\nCONTINUOUS\n';
  
  dxf += '0\nENDTAB\n';
  dxf += '0\nENDSEC\n';
  
  // Sección de entidades
  dxf += '0\nSECTION\n';
  dxf += '2\nENTITIES\n';
  
  // Exportar puntos
  points.forEach((point, index) => {
    // Punto como POINT
    dxf += '0\nPOINT\n';
    dxf += '8\nPUNTOS\n';
    dxf += `10\n${point.x.toFixed(3)}\n`;
    dxf += `20\n${point.y.toFixed(3)}\n`;
    dxf += `30\n${point.z.toFixed(3)}\n`;
    
    // Texto con el número del punto
    dxf += '0\nTEXT\n';
    dxf += '8\nPUNTOS\n';
    dxf += `10\n${point.x.toFixed(3)}\n`;
    dxf += `20\n${point.y.toFixed(3)}\n`;
    dxf += `30\n${point.z.toFixed(3)}\n`;
    dxf += '40\n1.0\n'; // Altura del texto
    dxf += `1\n${point.id || index + 1}\n`;
  });
  
  // Exportar curvas de nivel
  contourLines.forEach(contour => {
    contour.lines.forEach(line => {
      dxf += '0\nLINE\n';
      dxf += '8\nCURVAS\n';
      dxf += `10\n${line.start.x.toFixed(3)}\n`;
      dxf += `20\n${line.start.y.toFixed(3)}\n`;
      dxf += `30\n${line.start.z.toFixed(3)}\n`;
      dxf += `11\n${line.end.x.toFixed(3)}\n`;
      dxf += `21\n${line.end.y.toFixed(3)}\n`;
      dxf += `31\n${line.end.z.toFixed(3)}\n`;
    });
    
    // Etiqueta de nivel
    if (contour.lines.length > 0) {
      const firstLine = contour.lines[0];
      dxf += '0\nTEXT\n';
      dxf += '8\nCURVAS\n';
      dxf += `10\n${firstLine.start.x.toFixed(3)}\n`;
      dxf += `20\n${firstLine.start.y.toFixed(3)}\n`;
      dxf += `30\n${firstLine.start.z.toFixed(3)}\n`;
      dxf += '40\n0.5\n';
      dxf += `1\n${contour.level.toFixed(2)}\n`;
    }
  });
  
  // Exportar triangulación
  triangles.forEach(triangle => {
    const [p1, p2, p3] = triangle;
    
    // Línea 1-2
    dxf += '0\nLINE\n';
    dxf += '8\nTRIANGULOS\n';
    dxf += `10\n${p1.x.toFixed(3)}\n`;
    dxf += `20\n${p1.y.toFixed(3)}\n`;
    dxf += `30\n${p1.z.toFixed(3)}\n`;
    dxf += `11\n${p2.x.toFixed(3)}\n`;
    dxf += `21\n${p2.y.toFixed(3)}\n`;
    dxf += `31\n${p2.z.toFixed(3)}\n`;
    
    // Línea 2-3
    dxf += '0\nLINE\n';
    dxf += '8\nTRIANGULOS\n';
    dxf += `10\n${p2.x.toFixed(3)}\n`;
    dxf += `20\n${p2.y.toFixed(3)}\n`;
    dxf += `30\n${p2.z.toFixed(3)}\n`;
    dxf += `11\n${p3.x.toFixed(3)}\n`;
    dxf += `21\n${p3.y.toFixed(3)}\n`;
    dxf += `31\n${p3.z.toFixed(3)}\n`;
    
    // Línea 3-1
    dxf += '0\nLINE\n';
    dxf += '8\nTRIANGULOS\n';
    dxf += `10\n${p3.x.toFixed(3)}\n`;
    dxf += `20\n${p3.y.toFixed(3)}\n`;
    dxf += `30\n${p3.z.toFixed(3)}\n`;
    dxf += `11\n${p1.x.toFixed(3)}\n`;
    dxf += `21\n${p1.y.toFixed(3)}\n`;
    dxf += `31\n${p1.z.toFixed(3)}\n`;
  });
  
  dxf += '0\nENDSEC\n';
  dxf += '0\nEOF\n';
  
  return dxf;
};

export const downloadDXF = (dxfContent, filename = 'geomapper_export.dxf') => {
  const blob = new Blob([dxfContent], { type: 'application/dxf' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};